import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getUserEmail } from "../../../utils/auth";
import BASE_URL from "../../../config/apiConfig";
import "./SubscriptionPageList.css";

const SubscriptionPageList = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const email = getUserEmail();
        const response = await axios.post(
          `${BASE_URL}/api/payment/getTransactions`,
          { email }
        );

        if (response.data.transactions.length === 0) {
          setError("You don't have any subscriptions. Please purchase a plan.");
        } else {
          setTransactions(response.data.transactions);
        }
      } catch (err) {
        setError("Failed to fetch transactions. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  // Helper function to check if the subscription has expired
  const isSubscriptionExpired = (purchaseDate, frequency) => {
    const purchasedDate = new Date(purchaseDate);
    const expiryDate = new Date(purchasedDate);
    expiryDate.setMonth(expiryDate.getMonth() + frequency);

    return new Date() >= expiryDate;
  };

  return (
    <div className="subscription-page">
      <h1 className="subscription-title">My Subscriptions</h1>

      {loading ? (
        <div className="loading-container">
          <div className="loader"></div>
        </div>
      ) : error ? (
        <div className="empty-message-container">
          <p className="error-message">{error}</p>
          <button
            className="check-plans-button"
            onClick={() => navigate("/pricing")}
          >
            Check Plans
          </button>
        </div>
      ) : (
        <div className="subscriptions-container">
          {transactions.map((transaction) => {
            const subscriptionExpired = isSubscriptionExpired(
              transaction.created_at,
              transaction.payment_frequency
            );

            return (
              <div className="subscription-card" key={transaction.id}>
                <div className="card-header">
                  <h2 className="plan-name">{transaction.plan_name}</h2>
                  <button
                    className="add-farm-button"
                    onClick={() =>
                      navigate("/user/add-farm", {
                        state: {
                          cropName: transaction.crop_name,
                          landSize: transaction.remaining_land_size,
                          planName: transaction.plan_name,
                          razorpayOrderId: transaction.razorpay_order_id,
                          transactionId: transaction.id, // ✅ Add this line
                        },
                      })
                    }
                    disabled={subscriptionExpired}
                  >
                    {subscriptionExpired ? "Subscription Expired" : "Add Farm"}
                  </button>
                </div>
                <hr className="divider" />
                <p>
                  <strong>Crop:</strong> {transaction.crop_name}
                </p>
                <p>
                  <strong>Land Size:</strong> {transaction.land_size} Hectare
                </p>
                <p>
                  <strong>Remaining Land Size:</strong>{" "}
                  {transaction.remaining_land_size} Hectare
                </p>
                <p>
                  <strong>Payment Frequency:</strong>{" "}
                  {transaction.payment_frequency} months
                </p>
                <p>
                  <strong>Purchased Date:</strong>{" "}
                  {new Date(transaction.created_at).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SubscriptionPageList;
